import BackendService from "../../service/BackendService";

class SchoolsRepository {
  constructor() {
    this.backendService = new BackendService("schools");
  }

  async getSchools(ids) {
    if (ids) {
      return await this.backendService.getMany(ids);
    } else {
      return await this.backendService.getAll();
    }
  }

  async getSchoolById(id) {
    const school = await this.backendService.getOne(id);
    return school;
  }

  async getSchoolWithStats(id) {
    return await this.backendService.getSubResource(id, "stats");
  }

  async addSchool(params) {
    return await this.backendService.addOne(params);
  }
  async updateSchool(id, postData) {
    await this.backendService.updateOne(id, postData);
  }

  async deleteSchool(id) {
    await this.backendService.deleteOne(id);
  }

  async syncSchool(id, data) {
    const apiUrl = this.backendService.collectionUrl("schools") + id + "/sync";
    const accessToken = this.backendService.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const response = await this.backendService.instance.post(
      apiUrl,
      data,
      options
    );
    return response.data;
  }
}

export default SchoolsRepository;
